import { Address } from "../../utilities/address";
import { JsonProperty } from "../../utilities/json-property";
import { Price } from "../../utilities/price";
import { Division } from "../enums/division";
import { InvoiceStatus } from "../enums/invoice-status";
import { InvoiceType } from "../enums/invoice-type";
import { ShipmentType } from "../enums/shipment-type";

class PaymentTermsInfo {

    public id               : string = '';
    
    public discountDays     : number|undefined = undefined;
    
    public discountAmount   : number = 0.0;
    
    public dueDays          : number = 0; 

}

class CurrencyInfo {

    public id           : string = '';
    
    public symbol       : string = '';
    
    public exchangeRate : number = 0.0;

}

export class InvoiceReadOrder {

    public id           : string = '';
    
    public poNumber     : string = '';
    
    public jobName      : string = '';
    
    public quantity     : number = 0;
    
    public description  : string = '';
    
    public subtotal     : Price = new Price();
    
    public freight      : Price = new Price();
    
    public tax          : Price = new Price();
    
    public tariff       : Price = new Price();

}

class InvoiceLineItem {

    public id                   : number = 0;
    
    public orderId              : string = '';
    
    public quantity             : number = 0;
    
    public revenueCode          : string = '';
    
    public description          : string = '';
    
    public unitPrice            : Price = new Price();
    
    public unitCost             : number = 0.0;    
    
    public isTaxable            : boolean = false;
    
    public remark               : string = '';
    
    public creditReasonId       : number|undefined = undefined;
    
    public creditCategoryId     : number|undefined = undefined;

}

export class InvoiceRead {

    public id               : number|undefined = undefined;
    
    public invoiceNumber    : string = '';
    
    public type             : InvoiceType = InvoiceType.Purchase;
    
    public dealerId         : string = '';
    
    public groupId          : string = '';
    
    public dealerName       : string = '';
    
    public serviceCenter    : string = '';
    
    public division         : Division = Division.CD;
    
    public status           : InvoiceStatus = InvoiceStatus.Created;
    
    public shipmentType     : ShipmentType = ShipmentType.Delivery;
    
    @JsonProperty({ toType: 'datetime' })
    public shipmentTime?    : Date|undefined = undefined;
    
    @JsonProperty({ toType: 'date' })
    public invoiceDate      : Date;
    
    @JsonProperty('paymentTerms')
    public paymentTerms     : PaymentTermsInfo = new PaymentTermsInfo();
    
    @JsonProperty('currency')
    public currency         : CurrencyInfo = new CurrencyInfo();
    
    public billingAddress   : Address = new Address();
    
    public shippingAddress  : Address = new Address();
    
    public shipmentId       : number|undefined = undefined;
    
    public truckId          : number|undefined = undefined;
    
    public taxBasis         : Price = new Price();
    
    public taxRate          : number = 0.0;
    
    public subtotal         : Price = new Price();
    
    public freight          : Price = new Price();
    
    public tax              : Price = new Price();
    
    public tariff           : Price = new Price();
    
    public total            : Price = new Price();    
        
    @JsonProperty({ toType: 'datetime' })
    public createdOn        : Date;
    
    @JsonProperty({ toClass: InvoiceReadOrder, designType: 'array' })
    public orders           : InvoiceReadOrder[] = [];
    
    @JsonProperty({ toClass: InvoiceLineItem, designType: 'array' })
    public items            : InvoiceLineItem[] = [];
    
    public note             : string = '';

    constructor() {
        this.shipmentTime   = new Date();
        this.invoiceDate    = new Date();
        this.createdOn      = new Date();
    }
}
